function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
var useKYC = function useKYC() {
  var _window;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    cmsClient = _ref.cmsClient,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isKycCompleted = _useState4[0],
    setKycCompleted = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isKycProcessing = _useState6[0],
    setIsKycProcessing = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    claimInProgress = _useState8[0],
    setClaimInProgress = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    error = _useState0[0],
    setError = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showError = _useState10[0],
    setShowError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isUpdateWorkflow = _useState12[0],
    setUpdateWorkflow = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    loading = _useState14[0],
    setLoading = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    openKYCModal = _useState16[0],
    setOpenKYCModal = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    cashOutFlow = _useState18[0],
    setCashOutFlow = _useState18[1];
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.search) || ""
  };
  var queryParams = new URLSearchParams(location === null || location === void 0 ? void 0 : location.search);
  var status = queryParams.get("status");
  var process = queryParams.get("process");
  var moveToBankVerification = queryParams.get("cashOut");
  var rewardTypeSelected = queryParams.get("rewardTypeSelected");
  var utm_campaign = queryParams.get("utm_campaign");
  var rewardFormCompleted = utm_campaign === "MVouchersReferral";
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    bankstatus = _useState20[0],
    setBankStatus = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isKycFailed = _useState22[0],
    setIsKycFailed = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isBankVerificationFailed = _useState24[0],
    setIsBankVerificationFailed = _useState24[1];

  // config is injected via props to decouple from app config

  useEffect(function () {
    var timer = setTimeout(function () {
      setShowError(false);
    }, 3000);
    return function () {
      clearTimeout(timer);
    };
  }, [showError]);
  useEffect(function () {
    console.log(rewardFormCompleted);
    if (!!rewardFormCompleted) {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "POST",
        url: "/winnre/user/customer/claim-rewards"
      }).then(function (res) {
        // console.log('CLAIM REWARD', res);
        if ((res === null || res === void 0 ? void 0 : res.status) == "FAILED") {
          setStep(2); // Add code what happens if req fails
          return;
        }
        setOpenKYCModal(true);
        setKycCompleted(true);
        setStep(2);
      });
    }
  }, [rewardFormCompleted]);
  useEffect(function () {
    // initiateWorkflow('BANK_ACCOUNT_VERIFICATION');
    // initiateWorkflow('DIGILOCKER');

    //FOR UPDATE + CONFIRM SCREEN
    // setOpenKYCModal(true);
    // setStep(3);
    // console.log('MUSKAY', rewardFormCompleted);

    if (!!rewardFormCompleted) {
      return;
    }
    if (status === "success" && process === "DIGILOCKER") {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "GET",
        url: "/winnre/user/user/kyc-status?refresh=true"
      }).then(function (res) {
        console.log(res);
        if ((res === null || res === void 0 ? void 0 : res.message) === "COMPLETED") {
          if (moveToBankVerification == "true") {
            setCashOutFlow(true);
            checkBankVerificationStatus({
              kycStatus: "COMPLETED"
            });
            return;
          } else {
            setStep(7);
            setOpenKYCModal(true);
            return;
          }
        } else if ((res === null || res === void 0 ? void 0 : res.message) === "FAILED") {
          setKycCompleted(false);
          setIsKycFailed(true);
          setOpenKYCModal(true);
          setClaimInProgress(false);
          setStep(1);
          return;
        } else {
          return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
            method: "POST",
            url: "/winnre/user/change-kyc-status?status=PROCESSING"
          }).then(function (res) {
            console.log("Processing inside process Digilocker ", res);
            if (moveToBankVerification == "true") {
              setCashOutFlow(true);
              checkBankVerificationStatus({
                kycStatus: "PROCESSING"
              });
              return;
            } else {
              console.log("isKycProcessing state inside processing api call");
              setKycCompleted(true);
              setIsKycProcessing(true);
              setClaimInProgress(true);
              setStep(2);
              setOpenKYCModal(true);
            }
          });
        }
      });
    }

    // if (status === 'success' && process === 'BANK_ACCOUNT_VERIFICATION') {
    //     winnreAuth({
    //         method: 'GET',
    //         url: `/winnre/user/bank-account/verification-status`
    //     }).then((res) => {
    //         console.log(res);

    //         if (res?.message === 'COMPLETED') {
    //             setStep(5);
    //         } else if (res?.message === 'FAILED') {
    //             setKycCompleted(true);
    //             setIsBankVerificationFailed(true);
    //             setOpenKYCModal(true);
    //             setClaimInProgress(false);
    //             setStep(1);
    //             return;
    //         } else {
    //             setLoading(true);
    //             return winnreAuth({
    //                 method: 'POST',
    //                 url: `/winnre/user/bank-account/change-verification-status?status=PROCESSING`
    //             }).then((res) => {
    //                 console.log(res);
    //                 //  setStep(5);
    //                 setIsKycProcessing(false);
    //                 setStep(2);
    //                 setLoading(false);
    //             });
    //         }
    //     });
    //     setOpenKYCModal(true);
    //     setClaimInProgress(true);
    // }
    if (status === "success" && process === "BANK_ACCOUNT_VERIFICATION") {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "GET",
        url: "/winnre/user/bank-account/verification-status"
      }).then(function (res) {
        console.log(res);
        if ((res === null || res === void 0 ? void 0 : res.message) === "FAILED") {
          // Handle the failure case
          setKycCompleted(true);
          setIsBankVerificationFailed(true);
          setOpenKYCModal(true);
          setClaimInProgress(false);
          setStep(1);
          return;
        } else {
          // For all other statuses (e.g., COMPLETED, PROCESSING), set step 5
          setStep(5);
        }
      });

      // Open the KYC modal and set claim progress
      setOpenKYCModal(true);
      setClaimInProgress(true);
    }
  }, [process]);

  // console.log("Check Kyc Processing status inside useKyc" , isKycProcessing);

  useEffect(function () {
    if (rewardTypeSelected) {
      setStep(3);
      setOpenKYCModal(true);
    }
  }, [rewardTypeSelected]);
  var checkKycVerificationStatus = function checkKycVerificationStatus(forceInitate, silentCheck, cashoutProcess) {
    setLoading(true);
    setUpdateWorkflow(!!forceInitate);
    setCashOutFlow(!!cashoutProcess);
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "GET",
      url: "/winnre/user/user/kyc-status"
    }).then(function (res) {
      console.log("kyc", res);
      var data = "COMPLETED";
      setLoading(false);

      // this condition is not supposed to be used
      if ((res === null || res === void 0 ? void 0 : res.status) === "FAILED" && false) {
        // setLoading(false);
        setError(res === null || res === void 0 ? void 0 : res.message);
      } else {
        if ((res === null || res === void 0 ? void 0 : res.message) === "FAILED") {
          setKycCompleted(false);
          setClaimInProgress(false);
          setIsKycFailed(true);
          // setStep(6);
          setStep(1);
          return;
        }
        if ((res === null || res === void 0 ? void 0 : res.message) == "COMPLETED" && !forceInitate) {
          setKycCompleted(true);
          if (config !== null && config !== void 0 && config.manuallySelectReward && !cashoutProcess) {
            setStep(2);
            return;
          }
          checkBankVerificationStatus({});
        } else if ((res === null || res === void 0 ? void 0 : res.message) == "NOT_INITIATED" || (res === null || res === void 0 ? void 0 : res.message) == "INITIATED" || (res === null || res === void 0 ? void 0 : res.message) === "null" ||
        //    (res?.message === 'FAILED' && !config?.KycAndBankStatusCheckScreen)||
        forceInitate) {
          if (silentCheck) {
            setStep(1);
            return;
          }
          setKycCompleted(false);
          setClaimInProgress(false);
          setStep(1);
        } else if ((res === null || res === void 0 ? void 0 : res.message) == "PROCESSING") {
          setKycCompleted(true);
          setIsKycProcessing(true);
          if (config !== null && config !== void 0 && config.manuallySelectReward && !cashoutProcess) {
            setClaimInProgress(true);
            setStep(2);
            return;
          }
          checkBankVerificationStatus({
            kycStatus: "PROCESSING"
          });
        } else {
          setError("Something went wrong during KYC verification. Please try again after sometime");
        }
      }
    })["catch"](function (err) {
      // console.log(err);
      setLoading(false);
      setError("Something went wrong during KYC verification. Please try again after sometime");
    });
  };
  var checkBankVerificationStatus = function checkBankVerificationStatus(_ref2) {
    var forceInitate = _ref2.forceInitate,
      kycStatus = _ref2.kycStatus;
    setUpdateWorkflow(!!forceInitate);
    setLoading(true);
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "GET",
      url: "/winnre/user/bank-account/verification-status"
    }).then(function (res) {
      console.log("bank", res);
      setLoading(false);
      // this condition is not supposed to be used
      if ((res === null || res === void 0 ? void 0 : res.status) === "FAILED" && false) {
        setLoading(false);
        setError(res === null || res === void 0 ? void 0 : res.message);
      } else {
        var data = "FAILED";
        if ((res === null || res === void 0 ? void 0 : res.message) === "FAILED") {
          setIsBankVerificationFailed(true); // Set Bank Verification failure state
          setKycCompleted(true);
          setOpenKYCModal(true);
          setClaimInProgress(false);
          // setStep(6);
          setStep(1);
          // setLoading(false);
          return;
        }
        if ((res === null || res === void 0 ? void 0 : res.message) == "COMPLETED" && !forceInitate) {
          if (kycStatus == "PROCESSING") {
            setClaimInProgress(true);
            setStep(2);
            setOpenKYCModal(true);
            return;
          } else {
            setBankStatus(res === null || res === void 0 ? void 0 : res.message);
            setClaimInProgress(false);
            // setStep(3);
            setStep(0);
            setOpenKYCModal(true);
            return;
          }
        } else if ((res === null || res === void 0 ? void 0 : res.message) == "NOT_INITIATED" || (res === null || res === void 0 ? void 0 : res.message) == "INITIATED" || (res === null || res === void 0 ? void 0 : res.message) === "null" ||
        // (res?.message === 'FAILED' && !config?.KycAndBankStatusCheckScreen)||
        forceInitate) {
          if (kycStatus == "PROCESSING") {
            setIsKycProcessing(true);
          }
          setBankStatus("");
          setKycCompleted(true);
          setOpenKYCModal(true);
          setClaimInProgress(false);
          setStep(1);
          setLoading(false);
          return;
        } else if ((res === null || res === void 0 ? void 0 : res.message) == "PROCESSING") {
          setIsKycProcessing(false);
          setLoading(false);
          setClaimInProgress(true);
          setOpenKYCModal(true);
          setStep(2);
        } else {
          setError("Something went wrong during bank verification. Please try again after sometime");
          setLoading(false);
        }
      }
    })["catch"](function () {
      setLoading(false);
      setError("Something went wrong during bank verification");
    });
  };
  console.log("bankStatus state", bankstatus);
  var initiateWorkflow = function initiateWorkflow(type) {
    // console.log('Initiate workflow called');
    setLoading(true);
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "POST",
      url: "/winnre/user/kyc/initiate-workflow?workflowType=".concat(type)
    }).then(function (res) {
      var _winnreAuth$defaults, _config$logoLeft, _config$logo, _res$access_token;
      console.log("initiate workflow", res);
      var link = "".concat(window.location.href.split("?")[0], "?process=");
      if ((res === null || res === void 0 ? void 0 : res.status) === "FAILED") {
        setLoading(false);
        setError(res === null || res === void 0 ? void 0 : res.message);
        setShowError(true);
      } else if (!res.id) {
        setLoading(false);
        setError("Something went wrong during ".concat(type == "DIGILOCKER" ? "KYC" : "bank verification", " initiation. Please try again later"));
        return;
      }
      var digioOptions = {
        // trigger env to production for prod deployments
        environment: (winnreAuth === null || winnreAuth === void 0 || (_winnreAuth$defaults = winnreAuth.defaults) === null || _winnreAuth$defaults === void 0 ? void 0 : _winnreAuth$defaults.baseURL) === "https://prod.loyalie.in" ? "production" : "sandbox",
        is_redirection_approach: true,
        //for redirection
        is_iframe: false,
        redirect_url: link + type + "&cashOut=" + cashOutFlow,
        logo: (config === null || config === void 0 || (_config$logoLeft = config.logoLeft) === null || _config$logoLeft === void 0 ? void 0 : _config$logoLeft.url) || (config === null || config === void 0 || (_config$logo = config.logo) === null || _config$logo === void 0 ? void 0 : _config$logo.url) || "https://reloydev.s3.ap-south-1.amazonaws.com/Website/Uploads/Loyalie/Images/27822817.png",
        theme: {
          primaryColor: config === null || config === void 0 ? void 0 : config.primaryColor,
          secondaryColor: "#000000"
        }
      };
      var digio = new window.Digio(digioOptions);
      digio.init();
      // console.log(res.id, res.customer_identifier, res?.access_token?.id)
      digio.submit(res.id, res.customer_identifier, res === null || res === void 0 || (_res$access_token = res.access_token) === null || _res$access_token === void 0 ? void 0 : _res$access_token.id);
    })["catch"](function (err) {
      // console.log(err);
      setLoading(false);
      setError("Something went wrong during ".concat(type == "DIGILOCKER" ? "KYC" : "bank verification", " initiation"));
    });
  };
  var closeKYCModal = function closeKYCModal() {
    var _redux$dealAction;
    setStep(1);
    setError(null);
    setKycCompleted(false);
    if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction = redux.dealAction) !== null && _redux$dealAction !== void 0 && _redux$dealAction.setKycModalEnabled) {
      dispatch(redux.dealAction.setKycModalEnabled(false));
    }
    setClaimInProgress(false);
    setOpenKYCModal(false);
    setIsKycProcessing(false);
    setIsKycFailed(false); // Reset KYC failure state
    setIsBankVerificationFailed(false); // Reset Bank Verification failure state
    // getUserAccountSummary();
  };
  return {
    step: step,
    setStep: setStep,
    setError: setError,
    error: error,
    showError: showError,
    closeKYCModal: closeKYCModal,
    setOpenKYCModal: setOpenKYCModal,
    openKYCModal: openKYCModal,
    loading: loading,
    checkBankVerificationStatus: checkBankVerificationStatus,
    isUpdateWorkflow: isUpdateWorkflow,
    isKycCompleted: isKycCompleted,
    initiateWorkflow: initiateWorkflow,
    claimInProgress: claimInProgress,
    rewardTypeSelected: rewardTypeSelected,
    checkKycVerificationStatus: checkKycVerificationStatus,
    cashOutFlow: cashOutFlow,
    setClaimInProgress: setClaimInProgress,
    rewardFormCompleted: rewardFormCompleted,
    bankstatus: bankstatus,
    isKycFailed: isKycFailed,
    isBankVerificationFailed: isBankVerificationFailed,
    isKycProcessing: isKycProcessing
  };
};
export default useKYC;